<script lang="ts" setup>
    import { useUserStore } from '@/stores/user';
    import { useI18n } from 'vue-i18n';
    import { IToolUserSettings } from '@/types';
    import { cloneDeep } from 'lodash-es';
    import OrderSettingsInput from '@/components/orderSettings/OrderSettingsInput.vue';
    import { usePlatform } from '@/composables/usePlatform';
    import { useDisplay } from 'vuetify';

    const userStore = useUserStore();

    const { t } = useI18n();
    const display = useDisplay();
    const platform = usePlatform();
    const tab = ref<number>(0);
    const dialogOrderSettings = ref<boolean>(false);

    const toolUserSettingsDialog = ref<IToolUserSettings>({} as IToolUserSettings);

    onMounted((): void => {
        console.log('Component app-changeOrderSettingsDialog mounted.');
    });

    function open(): void {
        toolUserSettingsDialog.value = cloneDeep(userStore.settings);
        dialogOrderSettings.value = true;
    }

    defineExpose({ open });
</script>
<template>
    <v-dialog v-model="dialogOrderSettings" width="430" :scrim="false" :fullscreen="display.xs.value" :no-click-animation="true">
        <v-card class="pa-3 order-dialog">
            <v-card-title class="py-1 pl-3 pr-1 d-flex justify-space-between align-center" style="height: 48px">
                <span class="text-h5">{{ t('menu.orderSettings') }}</span>

                <v-btn density="compact" tag="a" :icon="mdiClose" @click="dialogOrderSettings = false" variant="text" size="36" />
            </v-card-title>
            <p class="pl-3 my-0 font13 font-weight-regular">
                <v-icon size="small" color="red" class="mb-1" :icon="mdiInformationOutline" />
                {{ t('menu.orderSettingsDisclaimer') }}
            </p>

            <!--            <v-form class="pl-4 pr-4">-->
            <v-card-text v-if="platform.isAggregator()" class="pa-0">
                <v-tabs color="grey-darken-2" v-model="tab" align-tabs="center">
                    <v-tab class="font14" color="grey-darken-1">
                        {{ t('menu.orderSettingsBookmaker') }}
                    </v-tab>
                    <v-tab class="font14" color="grey-darken-1">
                        {{ t('menu.orderSettingsInput') }}
                    </v-tab>
                </v-tabs>
                <v-tabs-window v-model="tab">
                    <v-tabs-window-item style="height: 465px">
                        <OrderSettingsBookmaker :toolUserSettingsDialog="toolUserSettingsDialog"></OrderSettingsBookmaker>
                    </v-tabs-window-item>

                    <v-tabs-window-item style="height: 465px">
                        <OrderSettingsInput :toolUserSettingsDialog="toolUserSettingsDialog"></OrderSettingsInput>
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-card-text>
            <v-card-text v-else class="pa-0">
                <OrderSettingsInput :toolUserSettingsDialog="toolUserSettingsDialog"></OrderSettingsInput>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<style scoped>
    .tab-item-wrapper {
        min-height: 335px;
    }

    .v-theme--dark .v-card.order-dialog {
        border: 1px solid #404148;
    }
</style>
